import "./style.css"

export type AlertVariant =
    | "info"
    | "warning"
    | "urgent"
    | "expired"
    | "success"
    | "danger"

interface AlertProps {
    variant: AlertVariant
    children: React.ReactNode
    className?: string
    showIcon?: boolean
}

export const Alert = ({
    variant,
    children,
    className = "",
    showIcon = true,
}: AlertProps) => {
    return (
        <div className={`custom-alert custom-alert--${variant} ${className}`}>
            {showIcon && (
                <div className="custom-alert-icon">
                    <i className="fas fa-exclamation-circle"></i>
                </div>
            )
            }
            <div className="custom-alert__content">
                {children}
            </div>
        </div >
    )
}
